/**
 * A generic function that does nothing
 * @params args - any arguments
 */
// Test change. TODO: Remove aftter BADGER-986
var noop = function noop() {
  return;
};
export default noop;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/noop.js
// module id = 2608
// module chunks = 11